// DRAFT legal texts: must be reviewed by a lawyer before relying on them.
export const LEGAL_UPDATED = { es: "10 de octubre de 2026", en: "10 October 2026" };
export const LEGAL_SLUGS = ["aviso-legal", "privacidad", "cookies", "condiciones"];

const OWNER = "Manuel Moscoso";
const NIF = "41740638P";
const ADDRESS = "Carrer Major, 29, La Fortesa, 08784 Piera (Barcelona), España";
const ADDRESS_EN = "Carrer Major, 29, La Fortesa, 08784 Piera (Barcelona), Spain";
const EMAIL = "mercatmenorcainfo@gmail.com";

export const LEGAL = {
  es: {
    "aviso-legal": {
      title: "Aviso legal",
      sections: [
        { h: "Titular del sitio web", p: [
          "En cumplimiento de la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de los datos del titular de Mercat Menorca:",
        ], list: [`Titular: ${OWNER}`, `NIF/CIF: ${NIF}`, `Domicilio: ${ADDRESS}`, `Email de contacto: ${EMAIL}`, "Sitio web: https://mercat-menorca.emergent.host"] },
        { h: "Objeto", p: [
          "Mercat Menorca es una plataforma gratuita de anuncios clasificados que permite a los usuarios publicar anuncios, buscar y contactar con otros usuarios en Menorca.",
        ] },
        { h: "Responsabilidad sobre los contenidos", p: [
          "Los anuncios, fotos y mensajes los publican los usuarios bajo su exclusiva responsabilidad. Mercat Menorca actúa como prestador de servicios de alojamiento de datos y no revisa los contenidos antes de su publicación, pero retirará con diligencia cualquier contenido ilícito del que tenga conocimiento efectivo.",
        ] },
        { h: "Propiedad intelectual", p: [
          "El diseño, el logotipo, los textos propios y el código de la web pertenecen a su titular. Los contenidos publicados por los usuarios siguen siendo suyos; al publicarlos nos autorizan a mostrarlos en la plataforma.",
        ] },
        { h: "Legislación aplicable", p: ["Este aviso legal se rige por la legislación española."] },
      ],
    },
    privacidad: {
      title: "Política de privacidad",
      sections: [
        { h: "Responsable del tratamiento", p: [
          `${OWNER}, con NIF/CIF ${NIF} y domicilio en ${ADDRESS}. Puedes contactarnos en ${EMAIL}.`,
        ] },
        { h: "Qué datos tratamos", list: [
          "Datos de cuenta: nombre, email, contraseña (cifrada) o tu identificador de Google si entras con Google, idioma y zona preferida.",
          "Fecha de nacimiento: para verificar tu edad y el acceso a la sección U LOVE U (+18).",
          "Fotos: de tus anuncios, de tu perfil y de tu perfil de U LOVE U.",
          "Mensajes y audios: los que envías y recibes en el chat.",
          "Anuncios: título, descripción, precio, zona y características.",
          "Denuncias y bloqueos: los usuarios que denuncias o bloqueas y el motivo.",
          "Datos técnicos: cookies de sesión necesarias para mantenerte conectado.",
        ] },
        { h: "Para qué y con qué base legal", list: [
          "Prestar el servicio (cuenta, anuncios, favoritos, chat): ejecución del contrato que aceptas al registrarte (art. 6.1.b RGPD).",
          "Verificar la edad y proteger a los menores: cumplimiento de obligaciones legales e interés legítimo (art. 6.1.c y 6.1.f RGPD).",
          "Gestionar denuncias, prevenir fraudes y mantener la seguridad: interés legítimo y obligaciones del Reglamento de Servicios Digitales (DSA).",
          "Enviarte emails de servicio (p. ej. restablecer la contraseña): ejecución del contrato.",
        ], p: ["No vendemos tus datos ni los usamos para publicidad. No tomamos decisiones automatizadas con efectos jurídicos sobre ti."] },
        { h: "Cuánto tiempo los conservamos", list: [
          "Cuenta, anuncios, fotos y mensajes: mientras tu cuenta esté activa. Si la eliminas, se borran en un plazo máximo de 30 días (salvo copias de seguridad, que se sobrescriben de forma periódica).",
          "Conversaciones que borras: desaparecen de tu bandeja; se eliminan del todo cuando ambos usuarios las borran o al eliminarse las cuentas.",
          "Denuncias y bloqueos: hasta 12 meses, o más si son necesarios para atender una reclamación o un requerimiento legal.",
          "Enlaces para restablecer la contraseña: caducan en 1 hora.",
        ] },
        { h: "Encargados del tratamiento", p: ["Para prestar el servicio trabajamos con estos proveedores, que solo tratan tus datos siguiendo nuestras instrucciones:"], list: [
          "Emergent: alojamiento de la web, base de datos y almacenamiento de archivos (fotos y audios).",
          "Resend: envío de emails del servicio.",
          "Google: inicio de sesión con Google, solo si eliges esta opción.",
        ], p2: ["Si algún proveedor trata datos fuera del Espacio Económico Europeo, lo hace con garantías adecuadas, como las Cláusulas Contractuales Tipo de la Comisión Europea."] },
        { h: "Tus derechos", p: [
          `Puedes ejercer tus derechos de acceso, rectificación, supresión, portabilidad, oposición y limitación del tratamiento escribiendo a ${EMAIL} e indicando el derecho que quieres ejercer. Te responderemos en el plazo máximo de un mes. También puedes editar tus datos y eliminar tu cuenta desde la propia web (Perfil → Mis datos / Ajustes).`,
          "Si consideras que no hemos atendido bien tu solicitud, puedes presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).",
        ] },
        { h: "Edad mínima", p: [
          "Para registrarte debes tener al menos 14 años (art. 7 LOPDGDD). La sección U LOVE U es solo para mayores de 18 años, y la edad se comprueba con la fecha de nacimiento.",
        ] },
      ],
    },
    cookies: {
      title: "Política de cookies",
      sections: [
        { h: "Solo cookies técnicas", p: [
          "Mercat Menorca solo usa cookies y almacenamiento local técnicos, necesarios para que la web funcione. No usamos cookies de análisis, de publicidad ni de terceros con fines de seguimiento, así que no necesitamos tu consentimiento (art. 22.2 LSSI-CE).",
        ] },
        { h: "Qué guardamos", list: [
          "access_token y refresh_token (cookies): mantienen tu sesión iniciada de forma segura. Duran mientras dura la sesión o hasta que cierras sesión.",
          "Idioma (localStorage): recuerda si prefieres español o inglés.",
          "Zona (localStorage): recuerda la zona de Menorca que has elegido.",
          "Avisos vistos (localStorage): recuerda que ya has visto este aviso de cookies y la pista para deslizar.",
        ] },
        { h: "Cómo eliminarlas", p: [
          "Puedes borrar las cookies y el almacenamiento local desde la configuración de tu navegador. Si lo haces, tendrás que volver a iniciar sesión.",
        ] },
      ],
    },
    condiciones: {
      title: "Condiciones de uso",
      sections: [
        { h: "El servicio", p: [
          "Mercat Menorca es gratuito y no cobra comisiones. Ponemos en contacto a personas que publican y buscan anuncios. Mercat Menorca no es parte de ninguna compraventa, alquiler ni acuerdo entre usuarios, y no garantiza el estado, la legalidad ni la veracidad de lo anunciado. Cada usuario es responsable de lo que publica y de los acuerdos que alcanza.",
          "Al registrarte aceptas estas condiciones y la Política de privacidad.",
        ] },
        { h: "Contenido prohibido", p: ["No está permitido publicar ni enviar:"], list: [
          "Productos o servicios ilegales, robados o que requieran autorización que no tienes.",
          "Armas, munición o explosivos.",
          "Drogas o sustancias ilegales, y medicamentos con receta.",
          "Falsificaciones o productos que vulneren derechos de propiedad intelectual.",
          "Estafas, pagos por adelantado sospechosos, cadenas o anuncios engañosos.",
          "Contenido que incite al odio, la violencia o la discriminación, o que acose a otras personas.",
          "Cualquier contenido que implique a menores de forma inapropiada.",
          "Desnudos o contenido sexual explícito, en fotos, textos o audios.",
          "Prostitución u ofrecimiento de servicios sexuales a cambio de dinero o cualquier otra contraprestación. Está expresamente prohibido en toda la web, incluida la sección U LOVE U.",
        ] },
        { h: "Normas de U LOVE U", list: [
          "Solo para mayores de 18 años. La edad se verifica con la fecha de nacimiento y una confirmación.",
          "La foto principal de tu perfil debe ser una foto real tuya: no se admiten dibujos, paisajes ni fotos de otras personas.",
          "Para pedir contacto necesitas un perfil de U LOVE U activo con 8 fotos.",
          "No se pueden enviar mensajes hasta que la otra persona acepta tu solicitud. Si la rechaza, no podrás volver a pedírselo.",
          "Puedes bloquear y denunciar a cualquier usuario en cualquier momento.",
        ] },
        { h: "Denunciar contenido ilegal (DSA)", p: [
          `Conforme al Reglamento (UE) 2022/2065 de Servicios Digitales, cualquier persona puede notificarnos contenido que considere ilegal o contrario a estas condiciones con el botón "Denunciar" de cada anuncio, perfil o chat, o escribiendo a ${EMAIL}. Indica el enlace o el usuario, el motivo y, si quieres, tus datos de contacto.`,
          "Revisamos las denuncias con diligencia y de forma objetiva. Si procede, retiramos el contenido o limitamos la cuenta e informamos al usuario afectado del motivo, que podrá responder escribiéndonos.",
        ] },
        { h: "Suspensión de cuentas", p: [
          "Podemos retirar contenidos y suspender o eliminar cuentas que incumplan estas condiciones o la ley, especialmente en casos graves o repetidos. Tú puedes eliminar tu cuenta cuando quieras desde Ajustes.",
        ] },
        { h: "Limitación de responsabilidad", p: [
          "El servicio se presta tal cual. En la medida permitida por la ley, Mercat Menorca no responde de los contenidos de los usuarios, de los acuerdos entre ellos ni de interrupciones técnicas puntuales. Nada de esto limita los derechos que te reconoce la normativa de consumidores.",
        ] },
        { h: "Ley aplicable", p: [
          "Estas condiciones se rigen por la legislación española. Si eres consumidor, serán competentes los juzgados de tu domicilio.",
        ] },
      ],
    },
  },
  en: {
    "aviso-legal": {
      title: "Legal notice",
      sections: [
        { h: "Website owner", p: [
          "In accordance with Spanish Law 34/2002 on Information Society Services and E-commerce (LSSI-CE), the owner of Mercat Menorca is:",
        ], list: [`Owner: ${OWNER}`, `Tax ID (NIF/CIF): ${NIF}`, `Address: ${ADDRESS_EN}`, `Contact email: ${EMAIL}`, "Website: https://mercat-menorca.emergent.host"] },
        { h: "Purpose", p: [
          "Mercat Menorca is a free classifieds platform where users can post listings, search, and contact other users in Menorca.",
        ] },
        { h: "Responsibility for content", p: [
          "Listings, photos and messages are posted by users, who are solely responsible for them. Mercat Menorca acts as a hosting service provider and does not review content before it is published, but it will promptly remove any illegal content it becomes aware of.",
        ] },
        { h: "Intellectual property", p: [
          "The website design, logo, own texts and code belong to the owner. Content posted by users remains theirs; by posting it, they allow us to display it on the platform.",
        ] },
        { h: "Governing law", p: ["This legal notice is governed by Spanish law."] },
      ],
    },
    privacidad: {
      title: "Privacy policy",
      sections: [
        { h: "Data controller", p: [
          `${OWNER}, tax ID ${NIF}, address ${ADDRESS_EN}. You can contact us at ${EMAIL}.`,
        ] },
        { h: "What data we process", list: [
          "Account data: name, email, password (encrypted) or your Google ID if you sign in with Google, language and preferred zone.",
          "Date of birth: to verify your age and access to the U LOVE U section (18+).",
          "Photos: from your listings, your profile and your U LOVE U profile.",
          "Messages and audio: those you send and receive in chat.",
          "Listings: title, description, price, zone and features.",
          "Reports and blocks: the users you report or block and the reason.",
          "Technical data: session cookies needed to keep you signed in.",
        ] },
        { h: "Purposes and legal bases", list: [
          "Providing the service (account, listings, favourites, chat): performance of the contract you accept when signing up (Art. 6.1.b GDPR).",
          "Verifying age and protecting minors: legal obligations and legitimate interest (Art. 6.1.c and 6.1.f GDPR).",
          "Handling reports, preventing fraud and keeping the service secure: legitimate interest and obligations under the Digital Services Act (DSA).",
          "Sending service emails (e.g. password reset): performance of the contract.",
        ], p: ["We don't sell your data or use it for advertising. We don't make automated decisions with legal effects on you."] },
        { h: "How long we keep it", list: [
          "Account, listings, photos and messages: while your account is active. If you delete it, they are erased within 30 days at most (except backups, which are overwritten periodically).",
          "Conversations you delete: they disappear from your inbox and are fully erased once both users delete them or the accounts are deleted.",
          "Reports and blocks: up to 12 months, or longer if needed to handle a claim or a legal request.",
          "Password reset links: expire after 1 hour.",
        ] },
        { h: "Processors", p: ["We use these providers to run the service. They only process your data on our instructions:"], list: [
          "Emergent: website hosting, database and file storage (photos and audio).",
          "Resend: sending service emails.",
          "Google: Google sign-in, only if you choose it.",
        ], p2: ["If a provider processes data outside the European Economic Area, it does so with appropriate safeguards such as the European Commission's Standard Contractual Clauses."] },
        { h: "Your rights", p: [
          `You can exercise your rights of access, rectification, erasure, portability, objection and restriction by emailing ${EMAIL} and stating which right you want to exercise. We will reply within one month. You can also edit your data and delete your account on the website itself (Profile → My data / Settings).`,
          "If you think we have not handled your request properly, you can lodge a complaint with the Spanish Data Protection Agency (www.aepd.es).",
        ] },
        { h: "Minimum age", p: [
          "You must be at least 14 years old to sign up (Art. 7 LOPDGDD). The U LOVE U section is for adults over 18 only, and age is checked using your date of birth.",
        ] },
      ],
    },
    cookies: {
      title: "Cookie policy",
      sections: [
        { h: "Technical cookies only", p: [
          "Mercat Menorca only uses technical cookies and local storage that are needed for the website to work. We don't use analytics, advertising or third-party tracking cookies, so we don't need your consent (Art. 22.2 LSSI-CE).",
        ] },
        { h: "What we store", list: [
          "access_token and refresh_token (cookies): keep you securely signed in. They last for the session or until you sign out.",
          "Language (localStorage): remembers whether you prefer Spanish or English.",
          "Zone (localStorage): remembers the Menorca zone you picked.",
          "Notices seen (localStorage): remembers that you've already seen this cookie notice and the swipe hint.",
        ] },
        { h: "How to delete them", p: [
          "You can clear cookies and local storage in your browser settings. If you do, you'll need to sign in again.",
        ] },
      ],
    },
    condiciones: {
      title: "Terms of use",
      sections: [
        { h: "The service", p: [
          "Mercat Menorca is free and charges no commissions. We connect people who post and look for listings. Mercat Menorca is not a party to any sale, rental or agreement between users, and does not guarantee the condition, legality or accuracy of what is listed. Each user is responsible for what they post and the agreements they make.",
          "By signing up you accept these terms and the Privacy policy.",
        ] },
        { h: "Prohibited content", p: ["You may not post or send:"], list: [
          "Illegal or stolen goods or services, or ones that require a licence you don't have.",
          "Weapons, ammunition or explosives.",
          "Drugs or illegal substances, and prescription medicines.",
          "Counterfeits or products that infringe intellectual property rights.",
          "Scams, suspicious advance payments, chain schemes or misleading listings.",
          "Content that incites hatred, violence or discrimination, or that harasses other people.",
          "Any content involving minors inappropriately.",
          "Nudity or sexually explicit content, in photos, text or audio.",
          "Prostitution or offering sexual services for money or any other consideration. This is explicitly forbidden across the whole website, including the U LOVE U section.",
        ] },
        { h: "U LOVE U rules", list: [
          "18+ only. Age is verified with your date of birth and a confirmation.",
          "Your profile's main photo must be a real photo of you: no drawings, landscapes or photos of other people.",
          "To request contact you need an active U LOVE U profile with 8 photos.",
          "No messages can be sent until the other person accepts your request. If they decline, you can't ask again.",
          "You can block and report any user at any time.",
        ] },
        { h: "Reporting illegal content (DSA)", p: [
          `Under the EU Digital Services Act (Regulation 2022/2065), anyone can notify us of content they consider illegal or against these terms using the "Report" button on any listing, profile or chat, or by emailing ${EMAIL}. Include the link or user, the reason and, if you wish, your contact details.`,
          "We review reports diligently and objectively. Where appropriate, we remove the content or restrict the account and tell the affected user why; they can reply by contacting us.",
        ] },
        { h: "Account suspension", p: [
          "We may remove content and suspend or delete accounts that break these terms or the law, especially in serious or repeated cases. You can delete your account at any time in Settings.",
        ] },
        { h: "Limitation of liability", p: [
          "The service is provided as is. To the extent permitted by law, Mercat Menorca is not liable for user content, agreements between users or occasional technical interruptions. None of this limits your rights under consumer law.",
        ] },
        { h: "Governing law", p: [
          "These terms are governed by Spanish law. If you are a consumer, the courts of your place of residence will have jurisdiction.",
        ] },
      ],
    },
  },
};
